module.exports = __webpack_public_path__ + "img/main-pic.11301cfb.svg";